import { default as i18next } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';

import { ConfigModel } from '@ibe/services';
import getExternalConfig from '../Config/externalConfigs';
import { ExternalParamsContextProps } from '../Config/ExternalParamsContext';
import { Language } from './index';
import MegConfigModel from '../Config/MegConfigModel';
import { appService } from '@ibe/components';

const order = ['widgetDOMDetector', 'querystring', 'localStorage', 'navigator'];

const widgetDOMDetector = {
  name: 'widgetDOMDetector',

  lookup(): string | undefined {
    return document.body.dataset.culture || document.body.dataset.locale; // the possible place where language will be defined in DOM (copied from test env)
  },

  cacheUserLanguage(lng: string) {
    localStorage.setItem('i18nextLng', lng);
  }
};

const customLanguageDetector = new LanguageDetector();
customLanguageDetector.addDetector(widgetDOMDetector);

const initI18next = async (externalParams?: ExternalParamsContextProps): Promise<void> => {
  let externalConfig: Partial<ConfigModel> = {};
  if (!!externalParams) {
    externalConfig = getExternalConfig(externalParams, externalConfig);
  }

  const config = appService.config as MegConfigModel;

  let version = '0';
  try {
    const rs = await fetch(
      `${externalConfig ? externalConfig.translationsUrl || '' : ''}/translations/generated/version`
    );
    version = await rs.text();
    if (Number.isNaN(Number.parseInt(version))) {
      version = '0';
    }
    console.debug('Translations version fetch ' + version);
  } catch (e) {
    console.debug('Translations version fetch failed.');
  }

  const emptyFallback = resourcesToBackend((lng: string, ns: string) => {
    console.warn(`[i18n] No translations found for ${ns}.${lng}, using empty bundle`);
    return Promise.resolve({});
  });

  await i18next
    .use(customLanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
      returnEmptyString:
        config?.translations?.useEmptyString === undefined
          ? true
          : config.translations.useEmptyString,
      fallbackLng: Language.EN,
      debug: false,
      interpolation: {
        escapeValue: false // not needed for react as it escapes by default
      },
      react: {
        useSuspense: true
      },
      ns: ['service-list', 'filter-option', 'filter-range', 'filter-dropdown'],
      backend: {
        backends: [HttpBackend, emptyFallback],
        allowMultiLoading: true,
        backendOptions: [
          {
            loadPath: `${
              externalConfig ? externalConfig.translationsUrl || '' : ''
            }/translations/generated/{{ns}}.{{lng}}.json`,
            queryStringParams: { v: version }
          }
        ]
      },
      detection: {
        order
      }
    });
};

export default initI18next;
